import React from "react";
import { IndigoTick } from "../svgs/svg";

export default function Tab(props) {
  return (
    <>
      {props.current === false && props.completed === false ? (
        <div className="flex-none w-[30px] h-[30px] bg-black bg-opacity-30 flex justify-center items-center rounded-full">
          <span>{props.num}</span>
        </div>
      ) : props.current === false && props.completed === true ? (
        <IndigoTick className={props.className}/>
        
      ) : (
        <div className="flex-none px-6 py-3 bg-orange-500 bg-opacity-30 rounded-3xl justify-start text-black text-xs lg:text-lg font-medium items-start gap-2.5 inline-flex">
            {props.label}
        </div>
      )}
    </>
  );
}
